// extracted by mini-css-extract-plugin
export default {"btn":"login_btn__I6Fc1"};